import { cn } from '@/lib/utils';

interface EditorialDividerProps {
  variant?: 'diamond' | 'line' | 'chapter';
  chapter?: string;
  className?: string;
}

/**
 * Three editorial separators. `diamond` ends sections, `line` is a hairline
 * rule, `chapter` shows a centered roman numeral framed by rules.
 */
export const EditorialDivider = ({
  variant = 'line',
  chapter,
  className,
}: EditorialDividerProps) => {
  if (variant === 'diamond') {
    return (
      <div className={cn('editorial-divider my-12', className)} aria-hidden="true">
        <span className="text-[10px] tracking-editorial">&#9670;</span>
      </div>
    );
  }

  if (variant === 'chapter' && chapter) {
    return (
      <div className={cn('editorial-divider my-16', className)} aria-hidden="true">
        <span className="font-display italic text-base text-brass/90 tracking-wide">
          {chapter}
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn('h-px bg-gradient-to-r from-transparent via-brass/25 to-transparent', className)}
      aria-hidden="true"
    />
  );
};